module.exports = __webpack_public_path__ + "img/9788972884118.f994b663.jpg";